<div class="editor-wrapper">

<quill-editor #editor
              (onContentChanged)="onContentChangedHandle($event)"
              name="editorContent"
              id='quillEditor'
              (onEditorCreated)="onEditorCreated($event)"
              [placeholder]="placeholder"
              [modules]="modules"
              (focusIn)="onEditorFocus($event)"
              (keydown)="onQuillKeyDown; onQuillKeydownEmoji($event)">
    <span  quill-editor-toolbar *ngIf="hideToolbar"></span>
    <div *ngIf="!hideToolbar" id="myToolbar" quill-editor-toolbar>
      <span class="ql-formats">
        <button class="ql-bold"></button>
        <button class="ql-italic"></button>
        <button class="ql-underline"></button>
        <select class="ql-size" *ngIf="fontSize"></select>
        <select class="ql-color"></select>
        <select class="ql-background"></select>
        <select class="ql-font">
          <option value="roboto">Roboto</option>
          <option value="montserrat">Montserrat</option>
          <option value="bangers">Bangers</option>
          <option value="birthstone">Birthstone</option>
          <option value="pacifico">Pacifico</option>
          <option value="caveat">Caveat</option>
          <option value="jura">Jura</option>
          <option value="limelight">Limelight</option>
          <option value="oregano">Oregano</option>
          <option value="handlee">Handlee</option>
          <option value="kranky">Kranky</option>
          <option value="eater">Eater</option>
          <option value="creepster">Creepster</option>
          <option value="nosifer">Nosifer</option>
          <option value="ranchers">Ranchers</option>
          <option value="chicle">Chicle</option>
          <option value="unkempt">Unkempt</option>
          <option value="moc">Christmas</option>
        </select>
        <select class="ql-align"></select>
        <select class="ql-align"></select>
        <button class="ql-link"></button>
        <button class="ql-image" ></button>
        <!-- <button class="ql-video"></button> -->
        <button id="emojiButton" (click)="toggleEmojiPopup()">😊</button>
      </span>


      <span class="ql-formats qlc-right" (click)="postComment()" *ngIf="showPostButton">
        <button class="qlc-post"></button>
      </span>
        <!--//COMMNET CANCEL-->
      <span class="ql-formats qlc-rightleft" (click)="cancelPostComment()">
        <button class="qlc-cancel"></button>
      </span>
    </div>
</quill-editor>



<div class="emoji-popup" *ngIf="showEmojiPopup" [ngStyle]="popupPosition" #emojiPopup>

  <div class="emoji-tabs">
    <button
      *ngFor="let tab of categories"
      (click)="onCategoryClick(tab.name)"
      [class.active]="activeCategory === tab.name && !searchMode">
      <span [innerHTML]="tab.icon"></span>
    </button>

    <!-- 🔎 Search button -->
    <button class="emoji-search-btn" (click)="openSearchMode()" [class.active]="searchMode" >
      🔍
    </button>
  </div>

  <!-- 🔥 NEW: separator bar -->
  <div class="emoji-separator"></div>

  <!-- SEARCH BAR: ONLY SHOWN IN SEARCH MODE -->
  <div class="emoji-search-wrapper" *ngIf="searchMode">
    <input
      *ngIf="searchMode"
      type="text"
      class="emoji-search"
      [(ngModel)]="searchTerm"
      placeholder="Search..."
      (input)="filterEmojis()"
    />

    <!-- ✖ close button -->
    <button class="emoji-search-close" (click)="closeSearchMode()">×</button>
  </div>

  <!-- RECENT EMOJIS -->
  <div *ngIf="recentEmojis.length > 0" class="emoji-recent">
    <div class="section-title">Recent</div>
    <div class="emoji-grid">
      <span *ngFor="let e of recentEmojis" (click)="insertEmoji(e, $event)">{{ e }}</span>
    </div>
  </div>

  <!-- SCROLLABLE GRID -->
  <div class="emoji-scroll">

    <div class="emoji-grid">
      <span *ngFor="let e of filteredEmojis" (click)="insertEmoji(e, $event)">
        {{ e }}
      </span>
    </div>
  </div>

</div>

<app-char-counter class="char_counter_style" [total]="10000" [count]="displayHtmlLength" tooltip="limit msg"></app-char-counter>

<div class="send-setting" [class.d-none]="state === 'close'" (clickOutside)="showSendSetting = false" *ngIf="showSetting">
<app-icon-setting size="18" (click)="showSendSetting = true" hoverColor="#262628" color="#D0D0D0"></app-icon-setting>
<div class="dropdown-menu" *ngIf="showSendSetting">
    <!-- Add close button to dialog box -->
    <div style="text-align: right"  (click)="showSendSetting = false" ><app-icon-close [title]="Close"></app-icon-close></div>
    <h2>Pressing Enter Key will:</h2>
    <label class="form-check-inline" (click)="onEnterSend(true)">
        <input class="form-check-input" type="radio" name="mode" [value]="true" [(ngModel)]="enterSend">
        <span>Send message</span>
    </label>
    <label class="form-check-inline" (click)="onEnterSend(false)">
        <input class="form-check-input" type="radio" name="mode" [value]="false" [(ngModel)]="enterSend">
        <span>Add a line break</span>
    </label>
</div>

</div> <!-- editor wrapper -->

<div id="ghost"></div>
<app-ok-modal #modal></app-ok-modal>
